import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import { setCookie, removeCookie, getCookie } from 'helpers/Storage';
import {
  API_BASEURL_OVERRIDE,
  DEBUG_PANEL_AD_DEBUG,
  DEBUG_PANEL_AD_SITE_SECTION,
  DEBUG_PANEL_API_BASEURL,
  DEBUG_PANEL_BLACKOUT_FETCH_INTERVAL,
  DEBUG_PANEL_CITY_LAT,
  DEBUG_PANEL_CITY_LONG,
  DEBUG_PANEL_CITY,
  DEBUG_PANEL_CLIENTLESS_RECURRING_PRE_AUTHZ_REFRESH,
  DEBUG_PANEL_CLIENTLESS_TOKEN_EXPIRE_REFRESH,
  DEBUG_PANEL_EMAIL_CAPTURE,
  DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_CURRENT_HOVER,
  DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_SIMPLIFIED_HOVER,
  DEBUG_PANEL_FLAG_BLACKOUT,
  DEBUG_PANEL_FLAG_BUYTHROUGH_EXTERNAL_SIGNUP_LOGIN,
  DEBUG_PANEL_FLAG_CCPA_OPT_OUT,
  DEBUG_PANEL_FLAG_COUNTDOWN_BANNER,
  DEBUG_PANEL_FLAG_DISABLE_REDIRECT,
  DEBUG_PANEL_FLAG_EPG_SEARCH,
  DEBUG_PANEL_FLAG_EPGV2,
  DEBUG_PANEL_FLAG_FNCV2,
  DEBUG_PANEL_FLAG_GLOBAL_PLAYER_AUTOPLAY,
  DEBUG_PANEL_FLAG_GLOBAL_PLAYER,
  DEBUG_PANEL_FLAG_HERO_CAROUSEL,
  DEBUG_PANEL_FLAG_MVPD_DEEPLINK,
  DEBUG_PANEL_FLAG_NATION_DIGITAL_CHANNEL,
  DEBUG_PANEL_FLAG_NATION_UNGATED_CTA,
  DEBUG_PANEL_FLAG_PERSONALITY_REDESIGN,
  DEBUG_PANEL_FLAG_PREVIEW_MODE,
  DEBUG_PANEL_FLAG_PREVIEW_PASS_60_MIN,
  DEBUG_PANEL_FLAG_PREVIEW_PASS,
  DEBUG_PANEL_FLAG_SECOND_SCREEN_PROFILE,
  DEBUG_PANEL_FLAG_SERIES_ANONYMOUS,
  DEBUG_PANEL_FLAG_SERIES_V2,
  DEBUG_PANEL_FLAG_STRIKE_BANNER,
  DEBUG_PANEL_FLAG_TILE_LIVE_TILE_V2,
  DEBUG_PANEL_FLAG_USE_MARINE_API_KEY,
  DEBUG_PANEL_LOCATION_COOKIE_DURATION,
  DEBUG_PANEL_TIMEOUT_DISABLED,
  DEBUG_PANEL_USER,
  DEBUG_PANEL_VIDEO_CDN,
  DEBUG_PANEL_VIDEO_ORIGIN,
} from 'helpers/ContentHelper';
import {
  blackoutDurationOverride,
  getFormattedDomain,
  getLocationCookieDuration,
  setDebugCookie,
  getMinSearchLength,
  setMinSearchLength,
  DEBUG_PANEL_MIN_SEARCH_LENGTH,
} from 'helpers/ConfigHelper';
import { fetchDmaOverrides, fetchPlayerConfig } from './DebugActions';
import BlackoutPanel from './panels/BlackoutPanel';
import AuthClientlessPanel from './panels/AuthClientlessPanel';
import ResetPanel from './panels/ResetPanel';
import LiveStreamPanel from './panels/LiveSteamPanel';
import LocationSettingsPanelComponent from './panels/LocationSettingsPanel';
import AdPanel from './panels/AdPanel';
import ApiPanel from './panels/ApiPanel';
import UserPanel from './panels/UserPanel';
import FeatureFlag from './panels/FeatureFlag';
import ErrorPanel from './panels/ErrorPanel';
import style from './Debug.module.scss';
import SearchSettings from './panels/SearchSettings';

class DebugScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      adDebug: null,
      adSiteSection: null,
      apiBaseUrl: null,
      cdnMapping: null,
      cookieKeys: [
        API_BASEURL_OVERRIDE,
        DEBUG_PANEL_AD_DEBUG,
        DEBUG_PANEL_AD_SITE_SECTION,
        DEBUG_PANEL_API_BASEURL,
        DEBUG_PANEL_BLACKOUT_FETCH_INTERVAL,
        DEBUG_PANEL_CITY_LAT,
        DEBUG_PANEL_CITY_LONG,
        DEBUG_PANEL_CITY,
        DEBUG_PANEL_CLIENTLESS_RECURRING_PRE_AUTHZ_REFRESH,
        DEBUG_PANEL_CLIENTLESS_TOKEN_EXPIRE_REFRESH,
        DEBUG_PANEL_EMAIL_CAPTURE,
        DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_CURRENT_HOVER,
        DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_SIMPLIFIED_HOVER,
        DEBUG_PANEL_FLAG_BLACKOUT,
        DEBUG_PANEL_FLAG_BUYTHROUGH_EXTERNAL_SIGNUP_LOGIN,
        DEBUG_PANEL_FLAG_CCPA_OPT_OUT,
        DEBUG_PANEL_FLAG_COUNTDOWN_BANNER,
        DEBUG_PANEL_FLAG_DISABLE_REDIRECT,
        DEBUG_PANEL_FLAG_EPG_SEARCH,
        DEBUG_PANEL_FLAG_EPGV2,
        DEBUG_PANEL_FLAG_FNCV2,
        DEBUG_PANEL_FLAG_GLOBAL_PLAYER_AUTOPLAY,
        DEBUG_PANEL_FLAG_GLOBAL_PLAYER,
        DEBUG_PANEL_FLAG_HERO_CAROUSEL,
        DEBUG_PANEL_FLAG_MVPD_DEEPLINK,
        DEBUG_PANEL_FLAG_NATION_DIGITAL_CHANNEL,
        DEBUG_PANEL_FLAG_NATION_UNGATED_CTA,
        DEBUG_PANEL_FLAG_PERSONALITY_REDESIGN,
        DEBUG_PANEL_FLAG_PREVIEW_MODE,
        DEBUG_PANEL_FLAG_PREVIEW_PASS_60_MIN,
        DEBUG_PANEL_FLAG_PREVIEW_PASS,
        DEBUG_PANEL_FLAG_SECOND_SCREEN_PROFILE,
        DEBUG_PANEL_FLAG_SERIES_ANONYMOUS,
        DEBUG_PANEL_FLAG_SERIES_V2,
        DEBUG_PANEL_FLAG_STRIKE_BANNER,
        DEBUG_PANEL_FLAG_TILE_LIVE_TILE_V2,
        DEBUG_PANEL_FLAG_USE_MARINE_API_KEY,
        DEBUG_PANEL_LOCATION_COOKIE_DURATION,
        DEBUG_PANEL_MIN_SEARCH_LENGTH,
        DEBUG_PANEL_TIMEOUT_DISABLED,
        DEBUG_PANEL_USER,
        DEBUG_PANEL_VIDEO_CDN,
        DEBUG_PANEL_VIDEO_ORIGIN,
      ],
      domain: null,
      selectedCity: null,
      selectedTimeout: null,
      videoOrigin: null,
    };
  }

  componentDidMount() {
    const { fetchDmaOverrides, fetchPlayerConfig } = this.props;
    const adDebug = getCookie({ name: DEBUG_PANEL_AD_DEBUG });
    const adSiteSection = getCookie({ name: DEBUG_PANEL_AD_SITE_SECTION });
    const apiBaseUrl = getCookie({ name: DEBUG_PANEL_API_BASEURL });
    const blackoutFetchDuration = blackoutDurationOverride();
    const cdnMapping = getCookie({ name: DEBUG_PANEL_VIDEO_CDN });
    const videoOrigin = getCookie({ name: DEBUG_PANEL_VIDEO_ORIGIN });
    const clientlessTokenExpireRefresh = getCookie({
      name: DEBUG_PANEL_CLIENTLESS_TOKEN_EXPIRE_REFRESH,
    });
    const clientlessRecurringPreAuthZRefresh = getCookie({
      name: DEBUG_PANEL_CLIENTLESS_RECURRING_PRE_AUTHZ_REFRESH,
    });
    const formattedDomain = getFormattedDomain();
    const locationCookieDurationMS = getLocationCookieDuration();
    const locationCookieDuration = locationCookieDurationMS / 3600 / 1000 / 24;
    const selectedCity = getCookie({ name: DEBUG_PANEL_CITY });
    const selectedTimeout = getCookie({ name: DEBUG_PANEL_TIMEOUT_DISABLED });
    const userData = getCookie({ name: DEBUG_PANEL_USER });
    const minSearchLength = getMinSearchLength();

    this.setState({
      adDebug,
      adSiteSection,
      apiBaseUrl,
      blackoutFetchDuration,
      cdnMapping,
      clientlessRecurringPreAuthZRefresh,
      clientlessTokenExpireRefresh,
      domain: formattedDomain,
      locationCookieDuration,
      selectedCity,
      selectedTimeout,
      userData: userData || {},
      minSearchLength,
      videoOrigin,
    });
    const route = _.get(window.ExternalConfig, 'debug.dmaOverrides');
    const playerConfigRoute = _.get(window.ExternalConfig, 'debug.playerConfig');
    if (playerConfigRoute) fetchPlayerConfig(playerConfigRoute);
    if (route) fetchDmaOverrides(route);
  }

  /**
   * Handles resetting everything.
   *
   */
  handleResetBtnClicked = () => {
    const { setCoordinates } = this.props;
    const { cookieKeys, domain } = this.state;
    const options = { domain, path: '/' };
    setCoordinates(null);
    this.setState(
      {
        adDebug: null,
        adSiteSection: null,
        apiBaseUrl: null,
        blackoutFetchDuration: null,
        cdnMapping: null,
        clientlessTokenExpireRefresh: null,
        locationCookieDuration: '',
        selectedCity: null,
        selectedTimeout: null,
        userData: {},
        videoOrigin: null,
        minSearchLength: 1,
      },
      () => {
        cookieKeys.forEach(key => {
          removeCookie({ key, options });
        });
      },
    );
  };

  handleSetAd = e => {
    e.preventDefault();
    const value = e.target.debugValue.value || null;
    this.setState({ adDebug: value }, () => {
      setDebugCookie({ name: DEBUG_PANEL_AD_DEBUG, value });
    });
  };

  handleSetAdSiteSection = e => {
    e.preventDefault();
    const value = e.target.siteSectionValue.value || null;
    this.setState({ adSiteSection: value }, () => {
      setDebugCookie({ name: DEBUG_PANEL_AD_SITE_SECTION, value });
    });
  };

  handleSetApiBaseUrl = e => {
    e.preventDefault();
    const { domain } = this.state;
    const value = e.target.value || 'false';
    const options = { domain, path: '/' };
    this.setState({ apiBaseUrl: value }, () => {
      setCookie({ name: DEBUG_PANEL_API_BASEURL, value, options });
      setCookie({ name: DEBUG_PANEL_FLAG_DISABLE_REDIRECT, value: true, options });
      this.setApiBaseUrlOverrideCookie(value);
    });
  };

  setApiBaseUrlOverrideCookie = overrideName => {
    const { domain } = this.state;
    const overrideBaseUrl = _.get(window.ExternalConfig.api, `content.baseUrls.${overrideName}`);
    const options = { domain, path: '/' };

    setCookie({ name: API_BASEURL_OVERRIDE, value: overrideBaseUrl, options });
  };

  handleSetBlackoutFetchInterval = e => {
    e.preventDefault();
    const { domain } = this.state;
    const { value } = e.target;
    const options = { domain, path: '/' };
    if (value) {
      this.setState({ blackoutFetchDuration: value }, () => {
        setCookie({ name: DEBUG_PANEL_BLACKOUT_FETCH_INTERVAL, value, options });
      });
    } else {
      this.setState({ blackoutFetchDuration: null }, () => {
        removeCookie({ key: DEBUG_PANEL_BLACKOUT_FETCH_INTERVAL, options });
      });
    }
  };

  handleSetCdnMapping = e => {
    const { domain } = this.state;
    const value = e.target.value || '';
    const options = { domain, path: '/' };
    this.setState({ cdnMapping: value }, () => {
      setCookie({ name: DEBUG_PANEL_VIDEO_CDN, value, options });
    });
  };

  /**
   * Sets the city and the lat long
   *
   * @param city
   */
  handleSetCity = city => {
    const { setCoordinates, cities } = this.props;
    const { domain } = this.state;

    const latlongIdx = _.findIndex(cities, c => c.dmaName === city);
    const latlong = _.get(cities, `${latlongIdx}.latlong`).split(',');
    const lat = latlong[0];
    const long = latlong[1];
    const options = { domain, path: '/' };

    // Set the cookie
    this.setState({ selectedCity: city }, () => {
      setCookie({ name: DEBUG_PANEL_CITY_LAT, value: lat, options });
      setCookie({ name: DEBUG_PANEL_CITY, value: city, options });
      setCookie({ name: DEBUG_PANEL_CITY_LONG, value: long, options });
    });
    setCoordinates({
      latitude: lat,
      longitude: long,
    });
  };

  handleSetClientlessRecurringPreAuthZRefresh = e => {
    e.preventDefault();
    const { domain } = this.state;
    const options = { domain, path: '/' };
    const value = e.target.value || null;
    this.setState({ clientlessRecurringPreAuthZRefresh: value });

    if (value) {
      setCookie({ name: DEBUG_PANEL_CLIENTLESS_RECURRING_PRE_AUTHZ_REFRESH, value, options });
    } else {
      removeCookie({ key: DEBUG_PANEL_CLIENTLESS_RECURRING_PRE_AUTHZ_REFRESH, options });
    }
  };

  handleSetClientlessTokenExpireRefresh = e => {
    e.preventDefault();
    const { domain } = this.state;
    const options = { domain, path: '/' };
    const value = e.target.value || null;
    this.setState({ clientlessTokenExpireRefresh: value });

    if (value) {
      setCookie({ name: DEBUG_PANEL_CLIENTLESS_TOKEN_EXPIRE_REFRESH, value, options });
    } else {
      removeCookie({ key: DEBUG_PANEL_CLIENTLESS_TOKEN_EXPIRE_REFRESH, options });
    }
  };

  handleMinSearchLength = e => {
    e.preventDefault();
    const value = _.toNumber(_.get(e, 'target.minSearchLength.value'));
    this.setState({ minSearchLength: value });
    setMinSearchLength(value);
  };

  handleSetLocationCookieDuration = e => {
    const { domain } = this.state;
    const options = { domain, path: '/' };
    const value = _.get(e, 'target.value', '');
    this.setState({ locationCookieDuration: value });

    if (value) {
      setCookie({ name: DEBUG_PANEL_LOCATION_COOKIE_DURATION, value, options });
    } else {
      removeCookie({ key: DEBUG_PANEL_LOCATION_COOKIE_DURATION, options });
    }
  };

  handleSetVideoOrigin = e => {
    const { domain } = this.state;
    const value = e.target.value || '';
    const options = { domain, path: '/' };
    this.setState({ videoOrigin: value }, () => {
      setCookie({ name: DEBUG_PANEL_VIDEO_ORIGIN, value, options });
    });
  };

  /**
   * Turns feature flags on or off.
   *
   * @param e
   */

  handleUserData = e => {
    e.preventDefault();
    const { domain, userData: currentUserData } = this.state;
    const options = { domain, path: '/' };
    const deviceId = e.target.deviceId.value || null;
    const userData = { ...currentUserData, deviceId /* some other user field */ };
    this.setState(userData, () => {
      setCookie({ name: DEBUG_PANEL_USER, value: userData, options });
    });
  };

  /**
   * Turns timeout on or off.
   *
   * @param e
   */
  handleToggleLiveStream = e => {
    const { domain } = this.state;
    const value = e.target.value || 'NO';
    const options = { domain, path: '/' };
    setCookie({ name: DEBUG_PANEL_TIMEOUT_DISABLED, value, options });
  };

  /**
   * Determines which panel to show.
   *
   */

  renderPanel = params => {
    const {
      playerConfig,
      segmentDeviceId,
      params: { panelId },
    } = this.props;
    const {
      adDebug,
      adSiteSection,
      apiBaseUrl,
      blackoutFetchDuration,
      cdnMapping,
      clientlessRecurringPreAuthZRefresh,
      clientlessTokenExpireRefresh,
      locationCookieDuration,
      selectedCity,
      selectedTimeout,
      userData,
      videoOrigin,
      minSearchLength,
    } = this.state;
    switch (panelId) {
      case 'authClientless': {
        return (
          <AuthClientlessPanel
            handleSetClientlessTokenExpireRefresh={this.handleSetClientlessTokenExpireRefresh}
            clientlessTokenExpireRefresh={clientlessTokenExpireRefresh}
            handleSetClientlessRecurringPreAuthZRefresh={
              this.handleSetClientlessRecurringPreAuthZRefresh
            }
            clientlessRecurringPreAuthZRefresh={clientlessRecurringPreAuthZRefresh}
          />
        );
      }
      case 'blackout': {
        return (
          <BlackoutPanel
            handleSetBlackoutFetchInterval={this.handleSetBlackoutFetchInterval}
            blackoutFetchDuration={blackoutFetchDuration}
          />
        );
      }
      case 'locationSettings': {
        const { cities } = params;
        return (
          <LocationSettingsPanelComponent
            cities={cities}
            handleSelect={this.handleSetCity}
            handleSetLocationCookieDuration={this.handleSetLocationCookieDuration}
            locationCookieDuration={locationCookieDuration}
            selectedCity={selectedCity}
          />
        );
      }
      case 'searchSettings': {
        return (
          <SearchSettings
            handleMinSearchLength={this.handleMinSearchLength}
            minSearchLength={minSearchLength}
          />
        );
      }
      case 'liveStream': {
        return (
          <LiveStreamPanel
            handleSetCdnMapping={this.handleSetCdnMapping}
            handleSetVideoOrigin={this.handleSetVideoOrigin}
            handleToggleLiveStream={this.handleToggleLiveStream}
            playerConfig={playerConfig}
            selectedCdnMapping={cdnMapping}
            selectedTimeout={selectedTimeout}
            selectedVideoOrigin={videoOrigin}
          />
        );
      }
      case 'feature-flags': {
        return <FeatureFlag />;
      }
      case 'adsDebug': {
        return (
          <AdPanel
            handleSetAd={this.handleSetAd}
            handleSetAdSiteSection={this.handleSetAdSiteSection}
            currentAdDebug={adDebug}
            currentSiteSection={adSiteSection}
          />
        );
      }
      case 'api': {
        return (
          <ApiPanel
            handleSetApiBaseUrl={this.handleSetApiBaseUrl}
            currentBaseUrl={apiBaseUrl}
            baseUrls={window.ExternalConfig.api.content.baseUrls}
          />
        );
      }
      case 'userPanel': {
        return (
          <UserPanel
            handleUserData={this.handleUserData}
            userData={userData}
            segmentDeviceId={segmentDeviceId}
          />
        );
      }
      case 'resetAll': {
        return <ResetPanel handleResetClick={this.handleResetBtnClicked} />;
      }
      case 'errorPanel': {
        return <ErrorPanel />;
      }
      default: {
        const { cities } = params;
        return (
          <LocationSettingsPanelComponent
            cities={cities}
            handleSelect={this.handleSetCity}
            handleSetLocationCookieDuration={this.handleSetLocationCookieDuration}
            locationCookieDuration={locationCookieDuration}
            selectedCity={selectedCity}
          />
        );
      }
    }
  };

  render() {
    const {
      cities,
      params: { panelId },
    } = this.props;
    const panelParams = {
      cities,
    };
    const separator = ' | ';
    const links = [
      <Link to="/debug/locationSettings" id="locationSettings" key="locationSettings">
        Location Settings
      </Link>,
      <Link to="/debug/liveStream" id="liveStream" key="liveStream">
        Live Stream
      </Link>,
      <Link to="/debug/feature-flags" id="featureFlag" key="featureFlags">
        Feature Flags
      </Link>,
      <Link to="/debug/adsDebug" id="adsDebug" key="adsDebug">
        Ads Debug
      </Link>,
      <Link to="/debug/blackout" id="blackout" key="blackout">
        Blackout
      </Link>,
      <Link to="/debug/authClientless" id="authClientless" key="authClientless">
        Clientless Auth
      </Link>,
      <Link to="/debug/userPanel" id="userPanel" key="userPanel">
        User
      </Link>,
      <Link to="/debug/api" id="api" key="api">
        Api
      </Link>,
      <Link to="/debug/searchSettings" id="searchSettings" key="searchSettings">
        Search Settings
      </Link>,
      <Link to="/debug/errorPanel" id="errorPanel" key="errorPanel">
        Errors
      </Link>,
      <Link to="/debug/resetAll" id="resetAll" key="resetAll">
        Reset All
      </Link>,
    ];
    const menuLinks = links.map((link, index) => {
      if (index < links.length - 1) return [link, separator];
      return link;
    });
    const renderSave =
      panelId === 'feature-flags' || panelId === 'api' || panelId === 'authClientless';
    return (
      <div className={style.debugContainer}>
        <div className={style.header}>
          <div className={style.title}>Fox Debug Panel</div>
          <div className={style.links}>{menuLinks}</div>
        </div>
        <div className={style.body}>{this.renderPanel(panelParams)}</div>
        {renderSave && (
          <button
            type="button"
            className={style.saveButton}
            onClick={() => {
              window.location.reload();
            }}
          >
            Refresh
          </button>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    cities: _.get(state, 'debug.dmaOverrides'),
    playerConfig: _.get(state, 'debug.playerConfig'),
  };
}

DebugScreen.defaultProps = {
  cities: null,
  playerConfig: null,
  segmentDeviceId: null,
};

DebugScreen.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.shape({})),
  fetchDmaOverrides: PropTypes.func.isRequired,
  params: PropTypes.shape({}).isRequired,
  fetchPlayerConfig: PropTypes.func.isRequired,
  playerConfig: PropTypes.shape({}),
  segmentDeviceId: PropTypes.string,
  setCoordinates: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { fetchDmaOverrides, fetchPlayerConfig })(DebugScreen);
